/* eslint-disable react/prop-types */
import React from "react";
import { DAY_IMAGES } from "../../edit-quotations/Constants";

const SLOTS = [
    { key: "morning", dayPart: "BREAKFAST", label: "Morning" },
    { key: "afternoon", dayPart: "LUNCH", label: "Afternoon" },
    { key: "evening", dayPart: "SNACK", label: "Evening" },
    { key: "night", dayPart: "DINNER", label: "Night" },
];

export default function ReminderTimings({ reminderTimings }) {
    const activeSlots = SLOTS.filter(slot => reminderTimings?.[slot.key]);
    if (activeSlots.length === 0) return null;

    return (
        <div className="bg-white rounded-2xl shadow-soft-xl p-5 flex items-center gap-6">
            <h2 className="text-sm font-semibold font-sans text-gray-700 whitespace-nowrap">
                Reminder Timings
            </h2>
            <div className="flex flex-row gap-4 flex-wrap">
                {activeSlots.map(slot => (
                    <div
                        key={slot.key}
                        className="flex items-center gap-2 border border-gray-200 rounded-xl px-3 py-1.5 bg-slate-50"
                    >
                        <img src={DAY_IMAGES[slot.dayPart]} className="h-6" alt="" />
                        <div className="flex flex-col leading-tight">
                            <span className="text-[10px] text-gray-400 font-sans uppercase tracking-wide">{slot.label}</span>
                            <span className="text-sm font-medium font-sans text-gray-800">{reminderTimings[slot.key]}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
